<template>
	<div class="column">
		<div class="col">
			<span class="text-overline">{{ $t('viewType') }}</span>
		</div>
		<div class="col">
			<q-btn-group>
				<q-btn @click="$emit('input', teaser)" icon="view_module" :class="viewButtonClass(teaser)"/>
				<q-btn @click="$emit('input', table)" icon="view_column" :class="viewButtonClass(table)"/>
			</q-btn-group>
		</div>
	</div>
</template>

<script>
	import {mapGetters} from "vuex";
  import {SEARCH_DISPLAY_TYPE, SEARCH_TYPE} from "@/common/constants";

  export default {
		name: "SearchViewSelect",
    props: {
      palletLogSearch: {
        type: Boolean,
        default: false
      },
    },
    computed: {
      ...mapGetters(['searchType', 'searchDisplayType', 'searchDisplayTypePallet', 'palletLogSearchDisplayType']),
      isPalletSearch() {
        return this.searchType === SEARCH_TYPE.PALLET;
      },
      teaser() {
        return SEARCH_DISPLAY_TYPE.TEASER;
      },
      table() {
        return SEARCH_DISPLAY_TYPE.TABLE;
      }
    },
		methods: {
			viewButtonClass(value) {
        if(this.palletLogSearch) {
          return value === this.palletLogSearchDisplayType ? 'bg-primary' : '';
        }
        if(this.isPalletSearch) {
          return value === this.searchDisplayTypePallet ? 'bg-primary' : '';
        }
				return value === this.searchDisplayType ? 'bg-primary' : '';
			}
		}
	}
</script>

<style scoped>

</style>